import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { DocumentUploadService } from '@xengage/gw-portals-document-js';

export default class ClaimService {

    static getClaimSummaries(query, offset, accountNumber = "", additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimSummaries', [query, offset, accountNumber], additionalHeaders);
    }

    static getClaimSummariesSnapshot(query, accountNumber = "", additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimSummariesSnapshot', [query, accountNumber], additionalHeaders);
    }
    

    static getClaimDetail(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimDetail', [claimNumber], additionalHeaders);
    }

    static getClaimPolicyDetail(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimPolicyDetail', [claimNumber], additionalHeaders);
    }

    static getClaimActivities(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimActivities', [claimNumber], additionalHeaders);
    }

    static getClaimNotes(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimNotes', [claimNumber], additionalHeaders);
    }

    static createClaimNote(claimNumber, noteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'createClaimNote', [claimNumber, noteDTO], additionalHeaders);
    }

    static updateClaimNote(claimNumber, note, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'updateClaimNote', [claimNumber, note], additionalHeaders);
    }

    static deleteClaimNote(claimId, noteId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'deleteClaimNote', [claimId, noteId], additionalHeaders);
    }

    static uploadDocument(file, documentMetadata, additionalHeaders = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('claimDocumentUpload'),
            file, documentMetadata, additionalHeaders);
    }

    static claimsDocUploadToken(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimDocs'),
            'generateUploadToken',
            params, additionalHeaders);
    }

    static claimsRemoveDocument(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimDocs'),
            'removeDocument',
            params, additionalHeaders);
    }

    static requestReport(claimDTO,additionalHeaders ={}) {
        return JsonRPCService.send(getProxiedServiceUrl('requestReport'),
           'requestReport',
           claimDTO, additionalHeaders)
    
        }

        static exportClaimDetail(claimNumber, additionalHeaders = {}) {
            return JsonRPCService.send(getProxiedServiceUrl('claim'),
                'exportClaimDetail', [claimNumber], additionalHeaders);
        }
        static exportPolicyClaimSummary(policyNumber, additionalHeaders={}) {
            return JsonRPCService.send(getProxiedServiceUrl('claim'),
                'exportPolicyClaimSummary',
                [policyNumber], additionalHeaders);
        }
    
        static exportAccountClaimSummary(accountNumber, additionalHeaders={}) {
            return JsonRPCService.send(getProxiedServiceUrl('claim'),
                'exportAccountClaimSummary',
                [accountNumber], additionalHeaders);
        }

        static deleteSelectedClaim(claimNumber, additionalHeaders = {}) {
            return JsonRPCService.send(getProxiedServiceUrl('claim'),
                'deleteSelectedClaim', [claimNumber], additionalHeaders);
        }
}
